import React, { Fragment, useState, useEffect } from 'react';
import requestApiService from '../../services/requestApi.service';
import Common from '../Common';
import { aiPromptLibraryFields, libraryHideFields } from './constants';
import { Col, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Button } from 'reactstrap';
import { useForm, Controller } from "react-hook-form";
import PopOverItem from '../../Common/PopOverItem';
import { useAppContext } from "../../Context/AppContext";
import { parseJSON } from 'date-fns';
import Select from "react-select";
import { showToast, stopAudio, translateContent } from '../../Common/Appcommon';
import Loading from '../../Common/Loading';
import CustomTable from '../../Common/CustomTable';

const AIPromptLibModal = (props) => {
    const { theme } = useAppContext();
    const isDark = theme === 'dark-theme';
    const { handleSubmit, control, reset, formState: { errors } ,setValue} = useForm({});
    const { rowData: initialRowData, libraryModalOpen,isAllowEdit,isLoading,allowNewConfig,knowledgeBase,selectedVoice,providerName} = props;
    const [isvoiceModalOpen , setVoiceModalOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState({
    });
    const [voiceData, setVoiceData] = useState([]);
    const [voiceColumn, setVoiceColumn] = useState([]);
    const [accentDropList, setAccentDropList] = useState([]);
    const [genderDropList, setGenderDropList] = useState([]);
    const [ageDropList, setAgeDropList] = useState([]);
    const [audioStates, setAudioStates] = useState("");
    const [saveLoading,setSaveLoading] = useState(isLoading);
    const [defAccentDrop, setDefAccentDrop] = useState(null);
    const [defGenderDrop, setDefGenderDrop] = useState(null);
    const [defAgeDrop, setDefAgeDrop] = useState(null);

    const [isRefresh, setIsRefresh] = useState(false);
    const [selectVoiceRow, setSelectVoiceRow] = useState("");
    const [provider, setProvider] = useState(initialRowData["provider"]);

    useEffect(() => {
        if (initialRowData && libraryModalOpen) {
            const resetData = { ...initialRowData };

            aiPromptLibraryFields.forEach(section => {
                section.fields.forEach(({ name, type }) => {
                    if (type === 'dropdown' && initialRowData[name] && name !== "voice") {
                        resetData[name] = {
                            label: initialRowData[name],
                            value: initialRowData[name]
                        };
                    }
                });
            });

            reset(resetData);
            setSelectedOption(prev => ({ ...prev, ...resetData }));
        }
    }, [initialRowData, libraryModalOpen, reset]);
    const handleToggle = () => {
        props.handlelibraryModalOpen();
    }

    const onSubmit = async (data) => {
        setSaveLoading(true);
        data["voice"] = selectVoiceRow["Name"];
        data["voice_id"] = selectVoiceRow["Voice_Id"];
        data["voice_provider"] = selectVoiceRow["Voice_Provider"];
        data["voice_url"] = selectVoiceRow["Audio_Url"] ?? selectVoiceRow["Custom_Url"] ?? "";
        props.onSubmit(data);
    };

    const fetchVoiceList = async (filter = "") => {
        if (provider) {
            const params = {
                ENTITY: "AIPROCESSOR",
                OPERATION: "GET_VOICE_PROVIDER",
                PROVIDER: provider,
                FILTER: filter,
                isOtherApiReq: true
            };
    
            try {
                const response = await requestApiService.processServerRequest(params);
                if (response.issuccess) {
                    const data = response.data;
                    if (data.length > 0) {
                        const column = await constructVoiceData(data);
                        const transformedVoiceData = data[0].map(item => ({ ...item, Icon: '' }));
                        const accentList = createDropDownList(data[0], 'Accent');
                        const genderList = createDropDownList(data[0], 'Gender');
                        const ageList = createDropDownList(data[0], 'Age');
                        setVoiceData(transformedVoiceData);
                        setVoiceColumn(column);
                        if (!filter) {
                            setDefAccentDrop(accentList[0]);
                            setDefGenderDrop(genderList[0]);
                            setDefAgeDrop(ageList[0]);
                            setAccentDropList(accentList);
                            setGenderDropList(genderList);
                            setAgeDropList(ageList);
                        }
                    } else {
                        setVoiceData([]);
                    }
                    handleVoiceModal();
                }
            } catch (error) {
                console.error("Error fetching voice list:", error);
            }
    
            setIsRefresh(true);
            setSelectVoiceRow("");
        }else{
            showToast(translateContent("vm.aiLibrary.providererror.msg"), "top-right", "error");
            return;
        }
        
    };

    const createDropDownList = (data, key) => {
        const uniqueValues = [...new Set(data.map(item => item[key]))];
        return uniqueValues.map(val => ({ label: val, value: val }));
    };

    const constructVoiceData = async (data) => {  
        const voice_column = [];
        const fields = data[1][0];  
        const aliases = data[1][1]; 
        voice_column.push({name: "", alias: "Icon"});
        fields.forEach((field, index) => {
            voice_column.push({
                name: field, 
                alias: aliases[index],
            });
        });
        voice_column.push({name: "", alias: "Url"});
        return voice_column; 
    };

    const createPromptModal = () => (
        <Modal className={'modal-lg'} isOpen={libraryModalOpen}>
            <ModalHeader toggle={handleToggle}> Create Prompt library </ModalHeader>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <ModalBody>
                    {promptLibraryForms()}
                </ModalBody>
                {isAllowEdit &&
                    <Row className='mb-3'>
                        <Col md="2" className='ms-auto'>
                        <Loading 
                            showLoader={saveLoading} 
                            mainContent = {
                                <Button className="btn-icon submit-btn btn-background" type="submit">
                                    Save
                                </Button>}
                        />
                        </Col>
                    </Row> 
                }
            </Form>
        </Modal>
    );

    const handleChange = (e, type = "") => {
        const { name, value } = e.target;
        initialRowData[name] = value;
       // props.onChange(name, value);
    };

    const onSelectChange = (name, option, field) => {
        field.onChange(option);
        setSelectedOption(prev => ({
            ...prev,
            [name]: option,
        }));
        if(name == "provider"){
            setProvider(option.value);
        }
    };

    const openModel = () =>{
        fetchVoiceList();
    }

    const handleVoiceModal = () => {
        setVoiceModalOpen(!isvoiceModalOpen);
    }
    const handleVoiceToggle = () =>{
        handleVoiceModal();
    }

    const saveSelectVoice = () => {
        if(selectVoiceRow === "" && voiceData.length > 0){
            showToast(translateContent("vm.agents.select.voice"));
            return;
        }
        const selectedVoiceName = selectVoiceRow["Name"];
        setValue("voice", selectedVoiceName); // This sets it to the input field named "voice"
        setSelectedOption(prev => ({
            ...prev,
            voice: selectedVoiceName
        }));
        setSelectVoiceRow(selectVoiceRow);
        handleVoiceModal();
    }

    const handleSelectRow = (voice) => {
        setIsRefresh(false);
        setSelectVoiceRow(voice);
    }

    const handleAudioStatus = (audio) =>{
        setAudioStates(audio);
    }

    const handleOnMenuOpen = (name, e, field) => {
        if(name == "modal_name" && provider == ""){
            showToast(translateContent("vm.aiLibrary.providererror.msg"), "top-right", "error");
        }
    }
    const getVoiceModalContent = () => {
        const dropdowns = [
            { name: "Accent", list: accentDropList, default: defAccentDrop },
            { name: "Gender", list: genderDropList, default: defGenderDrop },
            { name: "Age", list: ageDropList, default: defAgeDrop }
        ];
    
        return (
            <Modal isOpen={isvoiceModalOpen} contentClassName="voice-model-wid">
                <ModalHeader toggle={handleVoiceToggle}>
                    <span>Voice</span>
                    <span className='vm-voice-cnt'>{voiceData.length}</span>
                </ModalHeader>
                <ModalBody className="voice-modal-bdy">
                    <div className="d-flex-alone voice-drop">
                        {dropdowns.map(({ name, list, default: defaultVal }) => (
                            <div key={name} className="voice-drop-wid">
                                <Select
                                    placeholder={`---Choose ${name}---`}
                                    name={`${name.toLowerCase()}-fill`}
                                    className="basic-select"
                                    classNamePrefix="sub-select wa-select"
                                    value={defaultVal || null}
                                    options={list && list.length ? list : []}
                                    isDisabled={!list || !list.length}
                                    getOptionLabel={({ label }) => label}
                                    formatOptionLabel={({ value, label }, { context }) =>
                                        context === "value" ? (
                                            <div>{`${name} : ${label}`}</div>
                                        ) : (
                                            <div>{label}</div>
                                        )
                                    }
                                />
                            </div>
                        ))}
                    </div>
                    <CustomTable
                        agentVoiceId={selectedVoice}
                        data={voiceData}
                        columns={voiceColumn}
                        isSelect={true}
                        selectRow={handleSelectRow}
                        handleAudio={(e) => handleAudioStatus}
                        isRefresh={isRefresh}
                    />
                </ModalBody>
                <ModalFooter className="custom-modal-footer">
                    <Button
                        className="btn btn-secondary theme-bg-g"
                        onClick={() => saveSelectVoice()}
                    >
                        Select Voice
                    </Button>
                </ModalFooter>
            </Modal>
        );
    };
    
    const promptLibraryForms = () => {
        const visibleSections = aiPromptLibraryFields.filter(section =>
            section.fields.some(({ name }) => !(provider !== "" && libraryHideFields[provider]?.includes(name)))
        );
        return (
            <Fragment>
                {visibleSections.map((sectionData, sectionIndex) => {
                    const isLast = sectionIndex === visibleSections.length - 1;
                    const visibleFields = sectionData.fields.filter(({ name }) => {
                        return !(provider !== "" && libraryHideFields[provider]?.includes(name));
                    });
                    let lgNum = sectionData.section === "Role" ? "12" : "6";
                    let mdNum = sectionData.section === "Role" ? "6" : "4";

                    return (
                        <div className={`ps-2 pe-2 ${!isLast ? 'agent-div-container mb-3' : ''}`} key={sectionIndex}>
                            {sectionData.section}
                            <Row className="mt-2 mb-3 ps-3 pe-3">
                                {visibleFields.map(({ label, name, datalabel, type, placeholder, required, description, isDisabled, autoComplete, options, allowMulti }, index) => (
                                    <Col key={index} md={mdNum} lg={lgNum} className='mb-3'>
                                        <Label className="d-flex align-items-center label" htmlFor={name}>
                                            {label}
                                            {description && <PopOverItem id={index + "-config"} body={description} theme={isDark} />}
                                        </Label>
                                        <Controller
                                            name={name}
                                            control={control}
                                            rules={{ required: required ? `${label} is required` : false }}
                                            render={({ field }) => {
                                                if (type === "dropdown" && name !== "voice") {
                                                    let dropDownOption = options;
                                                    if (name === "modal_name") {
                                                        dropDownOption = options[provider] || [];
                                                    }
                                                    return (
                                                        <Select
                                                            name={name}
                                                            id={name}
                                                            className="basic-select"
                                                            classNamePrefix="sub-select wa-select"
                                                            value={selectedOption?.[name] || options[2]}
                                                            onChange={e => onSelectChange(name, e, field)}
                                                            options={dropDownOption}
                                                            isMulti={allowMulti}
                                                            isDisabled={!isAllowEdit}
                                                            onMenuOpen={e => handleOnMenuOpen(name, e, field)}
                                                        />
                                                    );
                                                } else {
                                                    return (
                                                        <Input
                                                            {...field}
                                                            type={type}
                                                            placeholder={placeholder}
                                                            className={`${errors[name] ? 'is-invalid' : ''}`}
                                                            onChange={(e) => {
                                                                field.onChange(e);
                                                                handleChange(e);
                                                            }}
                                                            disabled={!isAllowEdit}
                                                            autoComplete={"off"}
                                                            onClick={name === "voice" ? e => openModel(e) : undefined}
                                                        />
                                                    );
                                                }
                                            }}
                                        />
                                        {errors[name] && <em className="text-danger">{errors[name].message}</em>}
                                    </Col>
                                ))}
                            </Row>
                            {isvoiceModalOpen && getVoiceModalContent()}
                        </div>
                    );
                })}
            </Fragment>
        );
    };
    
    

    return (
        <Fragment>
            <Common
                title={"AI Prompt library"}
                titleContent={<span>AI Prompt library</span>}
                mainContent={<div>{createPromptModal()}</div>}
            />
        </Fragment>
    );
};

export default AIPromptLibModal;
